import { Article, WithContext } from 'schema-dts';

import { DEFAULT_STRUCTURE } from '../constants';
import type { OrganizationMapperResult } from './organization';

export type ArticleMapperResult = ReturnType<typeof articleMapper>;

export type ArticleMapperParams = {
  headline: string;
  image: string[];
  dateModified: string;
  datePublished: string;
  author: OrganizationMapperResult;
};

export const articleMapper = ({
  headline,
  image,
  dateModified,
  datePublished,
  author,
}: ArticleMapperParams): WithContext<Article> => ({
  ...DEFAULT_STRUCTURE,
  '@type': 'Article',
  headline,
  image,
  dateModified,
  datePublished,
  author,
});
